"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Scroll = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  max-height: 100vh;\n  overflow-y: auto;\n  padding: 0 1.5rem;\n  border-radius: 1rem;\n"], ["\n  max-height: 100vh;\n  overflow-y: auto;\n  padding: 0 1.5rem;\n  border-radius: 1rem;\n"])));
var templateObject_1;
//# sourceMappingURL=scroll.js.map